import { render, staticRenderFns } from "./RetentionPanel.vue?vue&type=template&id=5f8dd480&scoped=true"
import script from "./RetentionPanel.vue?vue&type=script&lang=js"
export * from "./RetentionPanel.vue?vue&type=script&lang=js"
import style0 from "./RetentionPanel.vue?vue&type=style&index=0&id=5f8dd480&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8dd480",
  null
  
)

export default component.exports